import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.css';
import { DataContext } from './context/DataContext';
import AppContext from './context/AppContext';
import CompMenue from './components/CompMenu';
import '@szhsin/react-menu/dist/index.css';
import Corporatebenefit from './components/job/corporate_benefit';
import nextway from './components/job/nextway';
import zeugnisse from './components/job/zeugnisse';
import benefitsme from './components/job/benefitsme';
import Login from './login';
import Logout from './logout';
import Home from './components/home/home';
import Arbeitsvorlagen from './components/arbeitsvorlagen/arbeitsvorlagen';
import Enkelwirtschaft from './components/enkelwirtschaft/enkelwirtschaft';
import Job from './components/job/job';
import Karriere from './components/karriere/karriere';
import Unternehmen from './components/unternehmen/unternehmen';
import Unternehmen_ur from './components/unternehmen/unternehmen_ur';
import Unternehmen_catering from './components/unternehmen/unternehmen_catering';
import Standorte from './components/standorte/standorte';
import Quality from './components/quality/quality';
import Az from './components/az/az';
import Links from './components/links/links';
import Nachricht from './components/nachricht/nachricht';
import Suche from './components/suche/suche';
import Report from './components/report/report';
import HardwareBestellung from './components/HardwareBestellung';
import { PushNotificationFCM } from './components/PushNotificationFCM';

function App () {
  const [ appLoggedIn, setAppLoggedIn ] = useState( false );
  const [ appLdapUsername, setAppLdapUsername ] = useState( '' );
  const [ appLdapFirstname, setAppLdapFirstname ] = useState( '' );
  const [ appLdapLastname, setAppLdapLastname ] = useState( '' );
  const [ appToken, setAppToken ] = useState( 'init' );
  const [ appShowToast, setShowToast ] = useState( false );
  const [ appToastMsg, setAppToastMsg ] = useState( '' );
  const [ appToastColor, setAppToastColor ] = useState( '' );

  async function getStorage ( bezeichnung: string, changeFunction: Function ) {
    let data = localStorage.getItem( bezeichnung );
    if ( data != '' && data != undefined ) {
      changeFunction( data );
    }
  }

  useEffect( () => {
    const getToken = async () => {
      let token = await localStorage.getItem( 'prc_token' );

      if ( token != '' && token != undefined ) {
        setAppLoggedIn( true );
        await getStorage( 'prc_token', setAppToken );
        await getStorage( 'prc_ldap_username', setAppLdapUsername );
        await getStorage( 'prc_ldap_first_name', setAppLdapFirstname );
        await getStorage( 'prc_ldap_last_name', setAppLdapLastname );
      }
    };
    getToken();
  }, [] );

  let dataContextValue = {
    appLoggedIn: appLoggedIn,
    appLoggedInChange: setAppLoggedIn,
    appShowToast: appShowToast,
    appShowToastChange: setShowToast,
    appToastMsg: appToastMsg,
    appToastMsgChange: setAppToastMsg,
    appToastColor: appToastColor,
    appToastColorChange: setAppToastColor,
    appToken: appToken,
    appTokenChange: setAppToken,
    getStorage: getStorage,
    appLdapUsername: appLdapUsername,
    appLdapUsernameChange: setAppLdapUsername
  };

  return (
    <DataContext.Provider value={ dataContextValue }>
      <AppContext />
      { appLoggedIn !== true ? (
        <Login />
      ) : (
        <>
          <Router>
            <div
              id="content"
              style={ {
                height: '100vh',
                display: 'flex',
                justifyContent: 'flex-start',
                flexDirection: 'column'
              } }
            >
              <PushNotificationFCM />
              <CompMenue />
              <Switch>
                <Route
                  exact
                  path="/"
                  component={ Home }
                />
                <Route
                  path="/karriere"
                  component={ Karriere }
                />
                <Route
                  path="/arbeitsvorlagen"
                  component={ Arbeitsvorlagen }
                />
                <Route
                  path="/enkelwirtschaft"
                  component={ Enkelwirtschaft }
                />

                <Route
                  path="/job"
                  component={ Job }
                />
                <Route
                  path="/corporatebenefit"
                  component={ Corporatebenefit }
                />
                <Route
                  path="/nextway"
                  component={ nextway }
                />
                <Route
                  path="/zeugnisse"
                  component={ zeugnisse }
                />
                <Route
                  path="/benefits"
                  component={ benefitsme }
                />
                <Route
                  path="/unternehmen"
                  component={ Unternehmen }
                />
                <Route
                  path="/unternehmen_ur"
                  component={ Unternehmen_ur }
                />
                <Route
                  path="/HardwareBestellung"
                  component={ HardwareBestellung }
                />
                <Route
                  path="/unternehmen_catering"
                  component={ Unternehmen_catering }
                />
                <Route
                  path="/standorte"
                  component={ Standorte }
                />
                <Route
                  path="/quality"
                  component={ Quality }
                />
                <Route
                  path="/az"
                  component={ Az }
                />
                <Route
                  path="/links"
                  component={ Links }
                />
                <Route
                  path="/suche"
                  component={ Suche }
                />
                <Route
                  path="/report"
                  component={ Report }
                />
                <Route
                  path="/logout"
                  component={ Logout }
                />
                <Route
                  path="/nachricht/:NewsId"
                  component={ Nachricht }
                />
              </Switch>
            </div>
          </Router>
        </>
      ) }
    </DataContext.Provider>
  );
}

export default App;
